import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import LetsDiscussYourGoals from "./sections/LetsDiscussYourGoals";
import TrustQualityValueProposition from "./sections/TrustQualityValueProposition";
import TheAutoprimePath from "./sections/TheAutoprimePath";
import MeetThePlayExperts from "./sections/MeetThePlayExperts";
import Features from "./sections/Features";
import VistaportFooter from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <LetsDiscussYourGoals />
      <TrustQualityValueProposition />
      <TheAutoprimePath />
      <MeetThePlayExperts />
      <Features />
      <VistaportFooter />
    </div>;
}